import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AppointmentTypeBadgeModule } from 'modules/appointments/components/appointment-type-badge/appointment-type-badge.module';
import { ModalSidebarModule } from 'shared/components/modal-sidebar/modal-sidebar.module';

import { PromptuaryFormCrmModule } from '../promptuary-form/crm/promptuary-form-crm.module';
import { PromptuaryFormModule } from '../promptuary-form/default/promptuary-form.module';
import { PromptuarySidebarComponent } from './promptuary-sidebar.component';

@NgModule({
	declarations: [PromptuarySidebarComponent],
	imports: [
		CommonModule,
		ModalSidebarModule,
		PromptuaryFormCrmModule,
		PromptuaryFormModule,
		TranslateModule.forChild(),
		FreudLoaderModule,
		AppointmentTypeBadgeModule,
	],
	exports: [PromptuarySidebarComponent],
	providers: [],
})
export class PromptuarySidebarModule {}
